module.exports = __webpack_public_path__ + "img/机构@3x.107c464f.png";